<template>
   <b-card no-body class="mb-2  w-100 " v-on:click="getDataSales">
        <b-card-header v-on:click="changeAngel = !changeAngel"  header-tag="header" class=" w-100 h-100 p-0" role="tab">
          <div  v-b-toggle="mes" variant="info" class="head-mes">
            <div class="mes">{{mes}}</div>
            <i v-if="!changeAngel" class="fas fa-angle-down arrow-angel"></i>
            <i v-if="changeAngel" class="fas fa-angle-up arrow-angel"></i>
          </div>
        </b-card-header>
        <b-collapse :id="mes" :accordion="mes" role="tabpanel">
          <b-card-body>
              <div v-if="dataSales.length > 0">
                <TableSalesReportsAccredited
                  v-for="(report, i) in reportEnterprise"
                  :key="i"
                  :dataSales="report"
                  :columns="columns"
                ></TableSalesReportsAccredited>
              </div>
              <div v-else>
                <div>Não houve venda neste mês.</div>
              </div>
          </b-card-body>
        </b-collapse>
    </b-card>
</template>

<script>
import BoardSaledReportsAccredited from './boardsalesreportsaccredited.js'
export default BoardSaledReportsAccredited
</script>

<style scoped>

.head-mes{
    display: flex;
    height: 50px;
    justify-content: space-between;
}
.mes{
    font-size: 14px;
    color: #727272;
    padding-top: 15px;
    padding-left: 15px;
    font-weight: 700;
}
.arrow-angel{
  padding-top: 10px;
  font-size: 30px;
  color: black;
  padding-right: 24px;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/salesbyaccredited/components/boardsalesreportsaccredited/boardsalesreportsaccredited.vue